import { useState } from "react";
import axios from "axios";
import { Send, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOPICS = [
  { value: "general", label: "General question" },
  { value: "products", label: "Product question" },
  { value: "coaching", label: "Wellness coaching" },
  { value: "merch", label: "Merch — notify me about new styles" },
];

const inputClass =
  "w-full rounded-2xl border border-forest/15 bg-white px-5 py-3.5 font-body text-sm text-ink placeholder:text-ink/35 focus:border-coral focus:outline-none focus:ring-2 focus:ring-coral/20 transition-all duration-300";

const ContactForm = ({ defaultTopic = "general" }) => {
  const [form, setForm] = useState({ name: "", email: "", topic: defaultTopic, message: "" });
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent! I'll get back to you soon ❤️");
      setForm({ name: "", email: "", topic: defaultTopic, message: "" });
    } catch (err) {
      toast.error("Something went wrong — please try again in a moment.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form data-testid="contact-form" onSubmit={submit} className="mt-8 space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <input
          data-testid="contact-name-input"
          type="text"
          required
          maxLength={100}
          placeholder="Your name"
          value={form.name}
          onChange={set("name")}
          className={inputClass}
        />
        <input
          data-testid="contact-email-input"
          type="email"
          required
          maxLength={120}
          placeholder="Your email"
          value={form.email}
          onChange={set("email")}
          className={inputClass}
        />
      </div>
      <select
        data-testid="contact-topic-select"
        value={form.topic}
        onChange={set("topic")}
        className={inputClass}
      >
        {TOPICS.map((t) => (
          <option key={t.value} value={t.value}>
            {t.label}
          </option>
        ))}
      </select>
      <textarea
        data-testid="contact-message-input"
        required
        maxLength={2000}
        rows={4}
        placeholder="Your message…"
        value={form.message}
        onChange={set("message")}
        className={`${inputClass} resize-none`}
      />
      <button
        type="submit"
        disabled={sending}
        data-testid="contact-submit-button"
        className="group inline-flex w-full items-center justify-center gap-3 rounded-full bg-coral px-10 py-5 font-display text-sm font-bold tracking-[0.15em] text-bone shadow-lg shadow-coral/30 transition-all duration-300 hover:scale-[1.02] hover:bg-coraldark disabled:opacity-60 disabled:hover:scale-100 sm:w-auto"
      >
        {sending ? <Loader2 className="h-5 w-5 animate-spin" /> : <Send className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />}
        {sending ? "SENDING…" : "SEND MESSAGE"}
      </button>
    </form>
  );
};

export default ContactForm;
